"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.getNumberOfProductsFromOrderlines = getNumberOfProductsFromOrderlines;
exports.isCartTotalGreaterThanMinimumOrderAmount = isCartTotalGreaterThanMinimumOrderAmount;

var _constants = _interopRequireDefault(require("./constants"));

var _uuid = require("uuid");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

/**
 * Returns the number of products.
 * @param {object} cart
 */
function getNumberOfProductsFromOrderlines(cart) {
  var number = cart.orderlines.reduce(function (total, currentValue) {
    return total + currentValue.number;
  }, 0);
  return number;
}
/**
 * Returns if the cart total is greater than the minimum order amount.
 * @param {object} cart
 * @param {number} minimumOrderAmount
 */


function isCartTotalGreaterThanMinimumOrderAmount(cart, minimumOrderAmount) {
  if (!cart || !cart.totals || !minimumOrderAmount) {
    return false;
  }

  var totals = cart.totals;
  var total = totals.subtotal - totals.discount + totals.shipping;
  return total > minimumOrderAmount;
}

var Cart = /*#__PURE__*/function () {
  function Cart(cart) {
    _classCallCheck(this, Cart);

    this.cart = cart;
  }

  _createClass(Cart, [{
    key: "initializeCart",
    value: function initializeCart() {
      var copyCart = JSON.parse(JSON.stringify(_constants["default"].DEFAULT_CART));
      copyCart.cart_id = (0, _uuid.v4)();
      copyCart.country = 'ES';
      copyCart.region = 'SPAIN';
      copyCart.start_date = new Date().toISOString();
      copyCart.modified_date = new Date().toISOString();
      this.cart = copyCart;
      return this.cart;
    }
    /**
     * Method to update some cart metadata when orderlines are updated.
     */

  }, {
    key: "orderlinesUpdated",
    value: function orderlinesUpdated() {
      this.cart.updated = true;
      this.cart.modified_date = new Date().toISOString();
      this.cart.number_products = getNumberOfProductsFromOrderlines(this.cart);
    }
  }, {
    key: "getUpdated",
    value: function getUpdated() {
      this.cart.modified_date = new Date().toISOString();
      this.cart.number_products = getNumberOfProductsFromOrderlines(this.cart);
      return this.cart;
    }
  }, {
    key: "_addProduct",
    value: function _addProduct(productData) {
      var priceDiscounted = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var subscriptionType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var subscriptionInterval = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var isPreCheckout = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

      // console.log('Adding product to cart: ', productData);
      if (!priceDiscounted) {
        priceDiscounted = parseFloat(productData.prices.discounted);
      }

      var productIndex = this.findProductIndex(productData.id, subscriptionType, isPreCheckout, productData['variationsSelection']);

      var isTrial = _constants["default"].TRIAL_PRODUCTS.includes(parseInt(productData.id));

      if (productIndex < 0) {
        // Product not found, add it
        var orderline = {
          id: parseInt(productData.id),
          name: productData.translation.name,
          image: productData.image,
          price: parseFloat(productData.prices.price),
          number: 1,
          presale: false,
          region: 'SPAIN',
          base_discount: parseFloat(productData.prices.base_discount),
          discounted: priceDiscounted,
          subscription_type: subscriptionType,
          subscription_interval: subscriptionInterval ? subscriptionInterval * 7 : null,
          symbol: productData.prices.symbol,
          format: productData.prices.format,
          is_pre_checkout: isPreCheckout
        };

        if (productData['variationsSelection']) {
          orderline['variationsSelection'] = productData['variationsSelection'];
        }

        if (isTrial) {
          orderline['type'] = 'trial';
        }

        this.cart.orderlines.push(orderline);
      } else {
        // Product found
        if (!isTrial) {
          if (subscriptionType) {
            if (subscriptionInterval) {
              this.cart.orderlines[productIndex].subscription_interval = subscriptionInterval * 7;
            }
          } else {
            // Only increment number in non trial and non subscription orderlines
            this.cart.orderlines[productIndex].number += 1;
          }
        }
      }
    }
    /**
     * Method to find first product index in cart orderlines, if it exists returns the index, otherwise returns -1.
     * It allows to find specific product by subscriptionType, isPreCheckout, and also by variationsSelection or find
     * any by setting findAny to true
     * @param {*} productId
     * @param subscriptionType
     * @param variationsSelection
     * @param isPreCheckout
     * @param findAny
     * @returns {Number} productIndex
     */

  }, {
    key: "findProductIndex",
    value: function findProductIndex(productId) {
      var subscriptionType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var isPreCheckout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var variationsSelection = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var findAny = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

      for (var i = 0; i < this.cart.orderlines.length; i++) {
        if (parseInt(this.cart.orderlines[i].id) === parseInt(productId)) {
          if (!findAny && (this.cart.orderlines[i].subscription_type !== subscriptionType || variationsSelection || this.cart.orderlines[i].is_pre_checkout && this.cart.orderlines[i].is_pre_checkout !== isPreCheckout)) {
            continue;
          }

          return i;
        }
      }

      return -1;
    }
    /**
     * Add a new product to the cart, with information we need.
     * @param {*} productData
     * @returns cart object
     */

  }, {
    key: "addProduct",
    value: function addProduct(productData) {
      var priceDiscounted = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var subscriptionType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var subscriptionInterval = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var isPreCheckout = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

      this._addProduct(productData, priceDiscounted, subscriptionType, subscriptionInterval, isPreCheckout);

      this.orderlinesUpdated();
      return this.cart;
    }
    /**
     * Adds a multiple new products to the cart, with information we need.
     * Does not support subscriptions.
     * @returns cart object
     * @param productsData
     */

  }, {
    key: "addMultipleProducts",
    value: function addMultipleProducts(productsData) {
      for (var i = 0; i < productsData.length; i++) {
        this._addProduct(productsData[i]);
      }

      this.orderlinesUpdated();
      return this.cart;
    }
    /**
     * Substract a product from the cart
     * @param {*} productId
     * @param  subscriptionType
     * @param {boolean} isPreCheckout
     * @returns
     */

  }, {
    key: "minusOne",
    value: function minusOne(productId, subscriptionType, isPreCheckout) {
      var productIndex = this.findProductIndex(productId, subscriptionType, isPreCheckout);

      if (productIndex >= 0) {
        this.cart.orderlines[productIndex].number -= 1;

        if (this.cart.orderlines[productIndex].number <= 0) {
          this.cart.orderlines.splice(productIndex, 1);
        }
      }

      this.orderlinesUpdated();
      return this.cart;
    }
    /**
     * Add a product to the cart
     * @param {*} productId
     * @param  subscriptionType
     * @param  {boolean} isPreCheckout
     * @returns cart object
     */

  }, {
    key: "plusOne",
    value: function plusOne(productId, subscriptionType, isPreCheckout) {
      var productIndex = this.findProductIndex(productId, subscriptionType, isPreCheckout);

      if (productIndex >= 0) {
        this.cart.orderlines[productIndex].number += 1;
      }

      this.orderlinesUpdated();
      return this.cart;
    }
    /**
     * Remove a product from the cart
     * @param {*} productId
     * @param  subscriptionType
     * @param {boolean} isPreCheckout
     * @returns cart object
     */

  }, {
    key: "removeProduct",
    value: function removeProduct(productId, subscriptionType, isPreCheckout) {
      var productIndex = this.findProductIndex(productId, subscriptionType, isPreCheckout);

      if (productIndex >= 0) {
        this.cart.orderlines.splice(productIndex, 1);
      }

      this.orderlinesUpdated();
      return this.cart;
    }
    /**
     * Returns whether the cart contains a subscription orderline
     * @returns boolean
     */

  }, {
    key: "hasSubscription",
    value: function hasSubscription(subscriptionType) {
      for (var i = 0; i < this.cart.orderlines.length; i++) {
        if (subscriptionType) {
          if (this.cart.orderlines[i].subscription_type === subscriptionType) {
            return true;
          }
        } else {
          if (this.cart.orderlines[i].subscription_type) {
            return true;
          }
        }
      }

      return false;
    }
    /**
     * Returns whether the cart contains any trial orderline
     * @returns boolean
     */

  }, {
    key: "hasTrial",
    value: function hasTrial() {
      for (var i = 0; i < this.cart.orderlines.length; i++) {
        if (this.cart.orderlines[i].type && this.cart.orderlines[i].type === 'trial') {
          return true;
        }
      }

      return false;
    }
    /**
     * Returns whether the cart promo_code_modified is more than 1 day old
     * @returns boolean
     */

  }, {
    key: "isPromoCodeOld",
    value: function isPromoCodeOld() {
      var now = new Date();
      var promoCodeModified = new Date(this.cart.promo_code_modified);
      var diff = now - promoCodeModified;
      var diffDays = Math.ceil(diff / (1000 * 3600 * 24));
      return diffDays > 1;
    }
    /**
     * Removes the promo applied to the cart:
     * Updates cart orderlines deleting discounted property,
     * removes promo_code and promo_code_modified and
     * it also empties the cart presents list
     * @returns cart object
     */

  }, {
    key: "removePromo",
    value: function removePromo() {
      for (var i = 0; i < this.cart.orderlines.length; i++) {
        delete this.cart.orderlines[i].discounted;
      }

      this.cart.promo_code = '';
      this.cart.promo_code_modified = null;
      this.cart.presents = [];
      this.orderlinesUpdated();
      return this.cart;
    }
  }]);

  return Cart;
}();

exports["default"] = Cart;